<div class="pos-absolute left-0 right-0 z-10 w-12 pe-auto meganav__content">
    <div class="ng-hide ng-hide-animate overflow-hidden meganav-inner"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="toggleGroupId"
         [elementHeight]="'meganav'">
        @for (item of items; track $index) {
        @if (ifCustomerGroup(item.visibility) && canPrintContent(item)) {
        <div class="w-12 bg-col-w m-r--100 ng-hide ng-hide-animate meganav-item-animation"
             [toggleClass]="'!ng-hide'"
             [toggleClassBy]="[toggleGroupId, $index]"
             pageHeaderMeganavContentArea
             (mouseenter)="handleMouseEnter($index)"
             (mouseleave)="handleMouseLeave($index)">
            <icms-outlet [components]="item.components"
                         [allowOnly]="allowOnly"
                         [options]="{ context: { toggleGroupId: [toggleGroupId, $index], tabName: item.text } }" />
        </div>
        }
        }
    </div>
</div>